import { LabelValue } from "./labelvalue";
import { RentalRatesDay } from "./rental-rates-day";
import { RentalRatesTerm } from "./rental-rates-term";

export class RentalRates {
    constructor(
        public YardiKey: string = null,
        public YardiUnitcode: string = null,
        public BestLeaseTermRent: number = null,
        public BestLeaseTermDate: Date = null,
        public BestLeaseTermDateShort: string = null,
        public BestLeaseTerm: number = null,
        public LeaseTerms: RentalRatesTerm[] = [],
        public DayTermOptions: RentalRatesDay[] = [],
        public LeaseTermsMap: Map<number, RentalRatesTerm> = new Map,
        public DayTermOptionsMap: Map<string, RentalRatesDay> = new Map,
        public DayTermRentMap: Map<string, number> = new Map,
        public LeaseTermOptions: LabelValue[] = []
    ) { }
}
